import React, { Component } from "react";
import styled from "styled-components";

const Range = styled.div`
  input[type="range"] {
    -webkit-appearance: none;
    background: radial-gradient(
      ellipse at center,
      rgba(98, 125, 77, 1) 0%,
      rgba(31, 59, 8, 1) 100%
    );
    cursor: pointer;
    height: 5px;
    margin: 0;
    transitionx: 0.1s ease-in;
    vertical-align: bottom;
    width: 100%;

    &::-webkit-slider-thumb {
    -webkit-appearance: none;
    background: radial-gradient(
      ellipse at center,
      rgba(98, 125, 77, 1) 0%,
      rgba(31, 59, 8, 1) 100%
    );
    border-radius: 20px;
    box-shadow: inset 0 0 0 5px #fff;
    border: 1px solid #000;
    height: 20px;
    width: 20px;
    transitionx: 0.1s ease-in;
  }

`;

class SliderField extends Component {
  render() {
    const {
      label,
      field: { name, value, onChange },
      min,
      max,
    } = this.props;
    return (
      <Range>
        <span>{label}</span>
        <input
          name={name}
          type="range"
          min={min}
          max={max}
          value={value}
          onChange={onChange}
        />
      </Range>
    );
  }
}

export default SliderField;
